/**
 * The create fields the Adapt menu (and Attach's Web sources row) set, as the create
 * endpoint reads them. Shared by the create screen and the Courses chat input, so a
 * resource the course agent makes gets exactly what the create screen would send.
 *
 * @param {Object} params
 * @param {Object[]} params.selectedReadingLevels - [{ id, name }]; the highest is primary
 * @param {Object[]} params.selectedLanguages - [{ name }]; English first when chosen
 * @param {('tier_2'|'tier_3'|null)} [params.selectedMtssTier] - the wire value (tier_1 is null)
 * @param {('auto'|'on'|'off')} [params.originalTextMode] - omitted when 'auto'
 * @param {('auto'|'on'|'off')} [params.webSourcesMode] - omitted when 'auto'
 * @returns {Object} fields to spread into the request body
 */
export const buildAdaptParams = ({
  selectedReadingLevels,
  selectedLanguages,
  selectedMtssTier = null,
  originalTextMode = 'auto',
  webSourcesMode = 'auto',
}) => {
  const sortedLanguages = [...selectedLanguages].sort((a, b) => {
    if (a.name === 'English') return -1;
    if (b.name === 'English') return 1;
    return 0;
  });
  const sortedReadingLevels = [...selectedReadingLevels].sort((a, b) => b.id - a.id);
  return {
    reading_level_id: sortedReadingLevels[0]?.id ?? undefined,
    language: sortedLanguages[0]?.name || undefined,
    secondary_reading_levels:
      sortedReadingLevels.length > 1 ? sortedReadingLevels.slice(1).map((l) => l.name) : undefined,
    secondary_languages:
      sortedLanguages.length > 1 ? sortedLanguages.slice(1).map((l) => l.name) : undefined,
    ...(selectedMtssTier ? { mtss_tier: selectedMtssTier } : {}),
    ...(originalTextMode !== 'auto' ? { keep_original_text: originalTextMode === 'on' } : {}),
    ...(webSourcesMode && webSourcesMode !== 'auto' ? { web_sources_mode: webSourcesMode } : {}),
  };
};
